import { GravyBinder } from "gravy-bind";
import Inputmask from "inputmask/dist/inputmask";
import reportValidity from 'report-validity';
import { Instance } from "inputmask/dist/inputmask";
import { AgencyPrincipalContactRequest } from "./models/contact/AgencyPrincipalContactRequest";
import { touchAllInputs } from "./utils/touch-all-inputs";
import { apiPost } from "./utils/api-post";

export class ContactAgencyPrincipal {
    public static cssClass = 'contact-agency-principal';
    private binder: GravyBinder;
    public data: AgencyPrincipalContactRequest;
    private phoneMask: Instance = Inputmask('999-999-9999');
    public loading: boolean = false;
    public submitted: boolean = false;

    constructor(private rootElement: HTMLFormElement) {
        this.data = new AgencyPrincipalContactRequest();
        this.rootElement.addEventListener('submit', this.onSubmit);
        this.binder = new GravyBinder(this, this.rootElement);
        this.phoneMask.mask(this.rootElement.querySelector('input[type=phone]') as HTMLInputElement)
        this.binder.updateOutwardBindings();
    }

    public onSubmit = async (event: Event): Promise<void> => {
        event.preventDefault();
        if (!this.loading && !this.submitted) {
            console.log('submitting contact request', this.data);

            touchAllInputs(this.rootElement);
            reportValidity(this.rootElement); // using polyfill instead of form.reportValidity for IE support

            // runs default behaviour (submitting) in case of validation success
            if (this.rootElement.checkValidity())
                await this.sendSubmission();
        }
    }

    public sendSubmission = async (): Promise<void> => {
        this.loading = true;
        this.binder.updateOutwardBindings();
        try {
            Object.keys(this.data).forEach(key => {
                if (!this.data[key]) this.data[key] = null;
            }); // change empty strings to null to prevent validation issues
            await apiPost('/api/contact/agency-principal', this.data);
            this.submitted = true;
        } catch (e) {
            console.error(e);
        }
        this.loading = false;
        this.binder.updateOutwardBindings();
    }
}